const SEEN_IDS_KEY = "baselineApprovalSubmitterSeenIds";

function readSeenSet() {
  try {
    const raw = localStorage.getItem(SEEN_IDS_KEY);
    const parsed = JSON.parse(raw || "[]");
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.map((id) => String(id || "").trim()).filter(Boolean));
  } catch {
    return new Set();
  }
}

function writeSeenSet(set) {
  try {
    const ids = [...set].slice(-500);
    localStorage.setItem(SEEN_IDS_KEY, JSON.stringify(ids));
  } catch {
    /* ignore */
  }
}

export function markBaselineSubmissionSeen(itemId) {
  const id = String(itemId || "").trim();
  if (!id) return;
  const set = readSeenSet();
  set.add(id);
  writeSeenSet(set);
}

export function markBaselineSubmissionsSeen(itemIds) {
  const set = readSeenSet();
  (itemIds || []).forEach((itemId) => {
    const id = String(itemId || "").trim();
    if (id) set.add(id);
  });
  writeSeenSet(set);
}

export function countUnseenBaselineRejections(items) {
  const seen = readSeenSet();
  return (items || []).filter((item) => {
    if (String(item?.state || "") !== "rejected") return false;
    const id = String(item?.id || "").trim();
    return id && !seen.has(id);
  }).length;
}
